export default "__VITE_ASSET__D88FYqTp__"